import { ButtonPrimary, ButtonSecondary } from 'components/Button'
import Column from 'components/Column'
import { Text } from 'rebass'
import { useTheme } from 'styled-components'

type StakePromptStepProps = {
  onStake: () => void
  onClose: () => void
  next: () => void
}

const StakePromptStep = ({ onStake, onClose }: StakePromptStepProps) => {
  const theme = useTheme()

  return (
    <Column gap="12px">
      <Text color={theme.textPrimary} fontSize={20} fontWeight={500}>
        Conversion Successful!
      </Text>
      <Text color={theme.textSecondary} fontSize={14}>
        Would you like to stake your xKDK to earn rewards?
      </Text>
      <ButtonPrimary onClick={onStake}>Stake xKDK</ButtonPrimary>
      <ButtonSecondary onClick={onClose}>Maybe later</ButtonSecondary>
    </Column>
  )
}

export default StakePromptStep
